import { Event } from './types'
import { eventBasedSynchronizer } from '$logic/lib/sync/event-based'

const syncronizer = eventBasedSynchronizer<{ events: Event[] }, true>(
  'analyticsSync',
  { merge: true },
)

export const set = syncronizer.set

export const getAll = syncronizer.getAll
